class StructureEditorType {
  static MARVIN = 'marvin';

  static CHEMDRAW = 'chemdraw';

  static allTypes = [StructureEditorType.MARVIN, StructureEditorType.CHEMDRAW];

  static settingsMap = {
    SE_MARVIN: StructureEditorType.MARVIN,
    SE_CHEMDRAW: StructureEditorType.CHEMDRAW,
  };

  static getFromSetting(setting) {
    return this.settingsMap[setting];
  }
}

export default StructureEditorType;
